<template>
    <div>
        <b-row>
            <b-col>
                <app-sub-title>Autorizaciones de Acceso</app-sub-title>
                <br />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-collapse>
                    <app-filters @filter="onFilter" />
                </app-collapse>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-list
                    ref="access-authorizations-list"
                    :filters="filters"
                    @access-authorization-form="accessAuthorizationForm"
                    @edit="onEditAuthorization"
                    @remove="onRemoveAuthorization"
                />
            </b-col>
        </b-row>
        <app-modal
            title="Nueva autorización"
            size="xl"
            id="access-authorization-form-window"
            @ok="$refs['access-authorization-form'].save()"
            ok-title="Guardar"
            :ok-disabled="busy"
            ok-icon="fa-save"
        >
            <app-form ref="access-authorization-form" @success="onSuccess" @busy="(status) => (busy = status)" />
        </app-modal>
    </div>
</template>
<script>
import appList from './List'
import appFilters from './Filters'
import appForm from './Form'

export default {
    components: {
        appList,
        appForm,
        appFilters,
    },
    data: () => ({
        filters: null,
        busy: false,
    }),
    methods: {
        onSuccess() {
            this.closeModal('access-authorization-form-window')
            this.$refs['access-authorizations-list'].refreshTable()
        },
        onFilter(filters) {
            this.filters = filters
            this.$refs['access-authorizations-list'].refreshTable()
        },
        accessAuthorizationForm() {
            this.openModal('access-authorization-form-window')
        },
        onEditAuthorization(authorization) {
            this.openModal('access-authorization-form-window')
            this.$nextTick(() => this.$refs['access-authorization-form'].edit(authorization))
        },
        async onRemoveAuthorization() {
            this.$refs['access-authorizations-list'].refreshTable()
        },
    },
}
</script>
